import React, { Component } from "react";
import Constants from "../constants";
import { Button, Label, Input } from "reactstrap";

import "../App.css";

class Modal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      validation: false
    };
  }

  setValidation = value => {
    this.setState({
      validation: value
    });
  };

  getValidation = () => {
    return this.state.validation;
  };

  render() {
    const { setDisplayModal, setYearLevel, getAcknowledge, setAcknowledge } = this.props;
    return (
      <div className="modal-bg">
        <div className="modal-wrapper">
          <div className="modal-container">
            <h2>Notice</h2>
            <p>
              You are now moving to maps with increased uncertainty. <br />
              Before using ground damage maps you should review these documents
              that list uncertainties.
            </p>
            <ul>
              <li>
                <a href="https://www.tauranga.govt.nz/Portals/0/data/living/natural_hazards/files/liquefaction-western-zone-report.pdf" target="_blank">Western Zone technical report</a>
              </li>
              <li>
                <a href="https://www.tauranga.govt.nz/Portals/0/data/living/natural_hazards/files/liquefaction-eastern-zone-report.pdf" target="_blank">Eastern Zone technical report </a>
              </li>
            </ul>

            <Label check>
              <Input
                type="checkbox"
                onChange={e => {
                  setAcknowledge(!getAcknowledge());
                }}
                checked={getAcknowledge()}
              />{" "}
              I acknowledge the uncertainties in these maps
            </Label>
            <div className={"buttonContainer"}>
              <Button
                className={getAcknowledge() ? "enabled" : "disabled"}
                onClick={() => {
                  if (!getAcknowledge()) {
                    this.setValidation(true);
                  } else {
                    this.setValidation(false);
                    setDisplayModal(false);
                    setYearLevel(1);
                  }
                }}
              >
                View Land Damage maps
              </Button>
              <Button
                className={"cancel-btn"}
                onClick={() => {
                  setDisplayModal(false);
                  setYearLevel(0);
                }}
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Modal;
